import { render, staticRenderFns } from "./actionType.vue?vue&type=template&id=20ded895&scoped=true"
import script from "./actionType.vue?vue&type=script&lang=js"
export * from "./actionType.vue?vue&type=script&lang=js"
import style0 from "./actionType.vue?vue&type=style&index=0&id=20ded895&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ded895",
  null
  
)

export default component.exports